import { FieldLabel } from 'smartsuite-ui';

function NumberInput(props) {
    const isValid = props?.isValid ?? true;
    function isValueInRange(
        value,
        min = Number.MIN_SAFE_INTEGER,
        max = Number.MAX_SAFE_INTEGER,
    ) {
        return value >= min && value <= max;
    }

    return (
        <div className="field">
            {props?.label && (
                <FieldLabel disabled={props?.disabled}>
                    {props.label}
                </FieldLabel>
            )}
            <div className="field__input-container">
                <div className="clearable-input-container">
                    <input
                        id={props?.id}
                        className={`input ${isValid ? '' : 'input--error'}`}
                        placeholder={props?.placeholder}
                        type="text"
                        inputMode="numeric"
                        onKeyDown={(event) => {
                            if (!['ArrowUp', 'ArrowDown'].includes(event.key)) {
                                return;
                            }

                            event.preventDefault();
                            const change = event.key === 'ArrowUp' ? 1 : -1;
                            const newValue = (
                                Number(event.target.value) + change
                            ).toString();

                            if (
                                isValueInRange(
                                    Number(newValue),
                                    props?.minNumber,
                                    props?.maxNumber,
                                )
                            ) {
                                event.target.value = newValue;
                                props?.onChange(event);
                            }
                        }}
                        value={props?.value}
                        onChange={(event) => {
                            // Remove non-numeric characters
                            event.target.value = event.target.value.replace(
                                /\D/g,
                                '',
                            );

                            if (
                                isValueInRange(
                                    Number(event.target.value),
                                    props?.minNumber,
                                    props?.maxNumber,
                                )
                            ) {
                                // Remove leading zeros
                                event.target.value = event.target.value.replace(
                                    /^0+(\d)/,
                                    '$1',
                                );
                                props?.onChange(event);
                            }
                        }}
                        required={props?.required}
                        disabled={props?.disabled}
                    />
                </div>
                {!isValid && (
                    <span className="field__error">{props?.errorMessage}</span>
                )}
            </div>
        </div>
    );
}

export default NumberInput;
